module.exports = __webpack_public_path__ + "img/vbuks.fc7bf123.png";